import { useEffect, useRef, useState } from "react";
import styles from "./Opportunities.module.css";
import { useDispatch, useSelector } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import { getEndingContracts } from "../../components/clients/clientsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { Tag } from "primereact/tag";
import { FilterMatchMode } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { Calendar } from "primereact/calendar";


export default function EndingContractsTab() {

    const mounted = useRef(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [detailsModalVisibility, setDetailsModalVisibility] = useState(false);
    const [oppDetailed, setOppDetailed] = useState(null)
    const [addOpportunitieModalVisible, setAddOpportunitieModalVisible] = useState(false)


    useEffect(() => {
        if (!mounted.current) {
            dispatch(getEndingContracts())
        }
        mounted.current = true
    }, [mounted])



    const isMobile = useSelector((state) => state.settings.isMobile);
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const endingContracts = useSelector((state) => state.clients.endingContracts)

    const [localEndingContractsList, setLocalEndingContractsList] = useState([])

    useEffect(() => { setLocalEndingContractsList(endingContracts) }, [endingContracts])

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        poste: { value: null, matchMode: FilterMatchMode.CONTAINS },
        collab_last_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        collab_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        client_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        contract_start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
        contract_end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    })
    const [globalFilterValue, setGlobalFilterValue] = useState('')

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const navToTeam = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.team_name);
        navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
        //setSelectedTeams([rowData.id_team])
    }

    const teamBodyTemplate = (rowData) => {
        if (rowData.team_name === null) {
            return (
                <Tag severity="warning" value="N/A" />
            )
        } else {
            return (
                <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.team_name}</a>
            )
        }
    }
    const clientBodyTemplate = (rowData) => {
        if (rowData.client_name === null) {
            return (
                <Tag severity="warning" value="N/A" />
            )
        } else {
            return (
                <Tag severity="success" value={rowData.client_name} />
            )
        }
    }
    const tableHeader = () => {
        return (<Row>
            <Col lg={6}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </Col>
            <Col md={6} className="d-flex justify-content-end">
            </Col>

        </Row>
        )
    }
    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy"
            mask="99/99/9999" />
    }

    const startDateTemplate = (rowData) => {
        if (rowData.team_start_date)
            return moment(rowData.team_start_date).format('DD/MM/YYYY')
    }
    const endDateTemplate = (rowData, field) => {
        if (rowData.team_end_date)
            return moment(rowData.team_end_date).format('DD/MM/YYYY')
    }

    let scrollHeight = "calc(100vh - 280px)"
    switch (isMobile) {
        case 2:
            scrollHeight = "calc(100vh - 330px)"
            break
        case 3:
            scrollHeight = "calc(100vh - 280px)"
            break
        default:
            break
    }

    return (
        <div className="bodyCard">
            <DataTable value={localEndingContractsList}
                scrollable
                scrollHeight={scrollHeight}
                paginator
                paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"}
                currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                rows={25}
                rowsPerPageOptions={[10, 25, 50]}
                draggable={false}
                filters={filters}
                globalFilterFields={['poste', 'collab_last_name', 'collab_name', 'team_name', 'client_name', 'contract_start_date', 'contract_end_date']}
                header={tableHeader}
                selectionMode="single"
            >
                <Column sortable filter field="poste" header={<Langs str="POSTE" />}></Column>
                <Column sortable filter field="collab_last_name" header={<Langs str="nom" />}></Column>
                <Column sortable filter field="collab_name" header={<Langs str="prenom" />}></Column>
                <Column sortable filter field="team_name" header={<Langs str="TEAM" />} body={teamBodyTemplate}></Column>
                <Column sortable filter field="client_name" body={clientBodyTemplate} header={<Langs str="CLIENT" />}></Column>
                <Column sortable filter field="contract_start_date" filterElement={dateFilterTemplate} dataType="date" header={<Langs str="START_DATE" />} body={startDateTemplate}></Column>
                <Column sortable filter field="contract_end_date" filterElement={dateFilterTemplate} dataType="date" header={<Langs str="END_DATE" />} body={endDateTemplate}> </Column>
            </DataTable>
        </div>
    )
}